import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { SftpFormComponent } from '@portal-core/licenses/components/license-connectors/sftp-form/sftp-form.component';
import { SyndicateFormComponent } from '@portal-core/licenses/components/license-connectors/syndicate-form/syndicate-form.component';
import { ConnectionType } from '@portal-core/publications/enums/publication-connection-type.enum';
import { Connector } from '@portal-core/publications/models/connector.model';
import { LoadingState } from '@portal-core/util/loading-state';

@Component({
  selector: 'mc-license-connectors-settings',
  templateUrl: './license-connectors-settings.component.html',
  styleUrls: ['./license-connectors-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LicenseConnectorsSettingsComponent implements OnInit {
  @Input() licenseId: number;
  @Input() licenseUserId: number = null;
  @Input() connector: Connector;

  @Output() cancel = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  @ViewChild('sftpForm', { static: false }) sftpFormComponent: SftpFormComponent;
  @ViewChild('syndicateForm', { static: false }) syndicateFormComponent: SyndicateFormComponent;
  @ViewChild('typeSelect', { static: true }) typeSelect: MatSelect;

  savingState: LoadingState<string> = new LoadingState<string>();
  ConnectionType: typeof ConnectionType = ConnectionType;

  get dirty(): boolean {
    return this.sftpFormComponent?.sftpForm.dirty ?? this.syndicateFormComponent?.syndicateForm.dirty;
  }

  get connectorType(): ConnectionType {
    return this.typeSelect?.value;
  }

  ngOnInit() {
    // set the type on edit
    this.connector ? this.typeSelect.writeValue(this.connector.ConnectionType) : null;
  }
}
